export const searchTypes = {
    STARTS_WITH: 'STARTS_WITH',
    CONTAINS: 'CONTAINS'
}